import React from 'react';
import '../../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../../hooks/useNotification/useNotification.es.js';
import '../../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../../utils/assertions.es.js';
import '../../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import { useControlled } from '../../../hooks/useControlled/useControlled.es.js';
import 'nanoid/non-secure';
import { Box } from '../../../primitives/Box/Box.es.js';
import '../../../primitives/Center/styled.es.js';
import '../../../primitives/Group/Group.es.js';
import '../../../primitives/Grid/Grid.es.js';
import '../../../primitives/Level/Level.es.js';
import '../../../primitives/Shelf/Shelf.es.js';
import '../../../primitives/Portal/Portal.es.js';
import '../../../primitives/Hidden/Hidden.es.js';
import '../../../primitives/Media/Media.es.js';
import '../../../primitives/Dialog/Dialog.es.js';
import { VisuallyHidden } from '../../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../../primitives/Popper/Popper.es.js';
import '../../../primitives/DragHandle/DragHandle.es.js';
import '../../../primitives/Pin/Pin.es.js';
import { forwardRef } from '../../../system/forwardRef.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Root = forwardRef((props, ref) => {
  const _a = props, {
    children,
    as = "input",
    value,
    name,
    id,
    isChecked: isCheckedProp,
    isIndeterminate,
    isDisabled,
    isInvalid,
    onChange,
    onClick,
    className,
    sx,
    wrapperProps,
    wrapperRef
  } = _a, rest = __objRest(_a, [
    "children",
    "as",
    "value",
    "name",
    "id",
    "isChecked",
    "isIndeterminate",
    "isDisabled",
    "isInvalid",
    "onChange",
    "onClick",
    "className",
    "sx",
    "wrapperProps",
    "wrapperRef"
  ]);
  const [isChecked, setIsChecked] = useControlled({ value: isCheckedProp, defaultValue: false });
  const handleChange = (event) => {
    onChange == null ? void 0 : onChange(event);
    setIsChecked(event.currentTarget.checked);
  };
  const handleWrapperClick = (event) => event.stopPropagation();
  return /* @__PURE__ */ React.createElement(Box, __spreadValues({
    as: "label",
    ref: wrapperRef,
    className,
    "data-state": isChecked || isIndeterminate ? "checked" : "unchecked",
    "data-invalid": isInvalid,
    "data-disabled": isDisabled,
    onClick: handleWrapperClick,
    sx
  }, wrapperProps), /* @__PURE__ */ React.createElement(VisuallyHidden, __spreadValues({
    as,
    ref,
    type: "checkbox",
    id,
    name,
    value,
    onChange: handleChange,
    onClick,
    checked: isChecked,
    disabled: isDisabled,
    "aria-invalid": isInvalid,
    "aria-checked": isIndeterminate ? "mixed" : isChecked
  }, rest)), children);
});
const Control = forwardRef((props, ref) => {
  const _a = props, { as = "div" } = _a, rest = __objRest(_a, ["as"]);
  return /* @__PURE__ */ React.createElement(Box, __spreadValues({
    ref,
    as
  }, rest));
});
const Label = forwardRef((props, ref) => {
  const _a = props, { children } = _a, rest = __objRest(_a, ["children"]);
  return /* @__PURE__ */ React.createElement(Box, __spreadValues({
    ref
  }, rest), children);
});
const Description = forwardRef((props, ref) => {
  const _a = props, { children } = _a, rest = __objRest(_a, ["children"]);
  return /* @__PURE__ */ React.createElement(Box, __spreadValues({
    ref
  }, rest), children);
});
const CheckboxPrimitive = Object.assign({}, { Root, Control, Label, Description });

export { CheckboxPrimitive };
//# sourceMappingURL=CheckboxPrimitive.es.js.map
